const { nextTick } = require('vue');

export const useScrollToElement = (elementRef, yOffset = 0) => {
	const scrollToElement = async () => {
		await nextTick();
		const y = elementRef.value.getBoundingClientRect().top + window.scrollY + yOffset;
		window.scrollTo({ top: y });
	};
	return { scrollToElement };
};
